module.exports = __webpack_public_path__ + "img/SX.1cba4337.png";